import { render, staticRenderFns } from "./delivery-staff-details.vue?vue&type=template&id=5ea0551e&"
import script from "./delivery-staff-details.vue?vue&type=script&lang=js&"
export * from "./delivery-staff-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports